import { Button, cn } from '@sunstone/ui';
import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme } from '../../hooks/useTheme';

export function ThemeToggle() {
  const { setTheme, theme } = useTheme();

  return (
    <div className="flex items-center gap-1">
      <Button
        variant="ghost"
        size="sm"
        aria-label="Light mode"
        onClick={() => setTheme('light')}
        className={cn(
          'cursor-pointer rounded-full',
          theme === 'light' && 'bg-accent text-accent-foreground',
        )}
      >
        <Sun className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        aria-label="System mode"
        onClick={() => setTheme('system')}
        className={cn(
          'cursor-pointer rounded-full',
          theme === 'system' && 'bg-accent text-accent-foreground',
        )}
      >
        <Monitor className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        aria-label="Dark mode"
        onClick={() => setTheme('dark')}
        className={cn(
          'cursor-pointer rounded-full',
          theme === 'dark' && 'bg-accent text-accent-foreground',
        )}
      >
        <Moon className="h-4 w-4" />
      </Button>
    </div>
  );
}
